/*
 *
 * SystemPopUp
 *
 * @version 1.0.0
 * @author Magarelli-Fabrizio
 * @since 03-Oct-2024
 */

import React from 'react'
import { defineMessages } from 'react-intl'
import PortalMessage from 'Hoc/PortalMessage'

const formattedMessage = {
  expiredTitle: (
    <PortalMessage
      id='t.app.project.popup.ttl.expired.title'
      defaultMessage='Your session has expired due to inactivity.'
    />
  ),
  extendedTitle: <PortalMessage id='t.app.project.popup.ttl.title' defaultMessage='The session is about to expire' />,
  errorTitle: <PortalMessage id='t.app.project.popup.default.error.title' defaultMessage='Oops!' />,
  errorSubTitle: (
    <PortalMessage id='t.app.project.popup.default.error.subtitle' defaultMessage='Something went wrong' />
  ),
  errorButton: <PortalMessage id='t.app.project.btn.close' defaultMessage='Close' />,
  expiredButton: <PortalMessage id='t.app.project.popup.ttl.expired.button' defaultMessage='Back to login' />,
  extendedButton: <PortalMessage id='t.app.project.popup.ttl.button' defaultMessage='Stay Connected' />
}

export const ariaLabels = defineMessages({
  extendedTitleAriaLabel: {
    id: 't.app.accessibility.popup.ttl.title.ariaLabel',
    defaultMessage: 'The Modal title is: The session is about to expire'
  },
  expiredTitleAriaLabel: {
    id: 't.app.accessibility.popup.ttl.expired.title.ariaLabel',
    defaultMessage: 'The Modal title is: The session has expired'
  },
  errorTitleAriaLabel: {
    id: 't.app.accessibility.popup.default.error.title.ariaLabel',
    defaultMessage: 'The Modal title is: Oops!'
  },

  errorSubTitleAriaLabel: {
    id: 't.app.accessibility.popup.default.error.subtitle.ariaLabel',
    defaultMessage: 'The Modal description is: Something went wrong'
  }
})

export default formattedMessage
